import styled from 'styled-components'

const S = {}

S.StepsWrapper = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 15px;

    @media (max-width: 768px) {
      max-width: fit-content;
    }

`;

S.StepsList = styled.ul`
    list-style-type: none;
    display: flex;
    flex-direction: column;
    padding: 0;

    & .odd {
        margin: 0 auto 0 0;
    }
    & .even {
        margin: 0 0 0 auto;

        & .title-wrapper {
            flex-direction: row-reverse;

            @media (max-width: 768px) {
                flex-direction: row;
            }
        }
    }
`;


S.Step = styled.li`
    width: 50%;

    @media (max-width: 768px) {
      width: 100%;
    }

    & .title-wrapper {
        padding-bottom: 10px;
        display: flex;
        align-items: center;
        position: relative;

        & ::after {
            content: '';
            width: 100%;
            height: 3px;
            background: #00000080;
            position: absolute;
            bottom: 0;
            left: 0;
        }
        & .number {
            padding: 10px;
            font-size: 48px;
            font-weight: 700;
            color: #22283B;
        }
        & .separator {
            margin: 0 5px;
            width: 5px;
            height: 50px;
            background: #ddd;
        }
        & .title {
            margin: 0 10px;
            font-size: 24px;
            color: #2d2d2d;
        }
    }

    & .description-wrapper {
        & p {
            line-height: 24px;
            letter-spacing: .4px;
        }
    }

    & .image-wrapper {
        & img {
            width: 100%;
            border-radius: 8px;
        }
    }
`;


export default S;